import Poems from '../../views/Poem/Poems'

export default [
    {
        path: '/poems',
        name: 'poems',
        component: Poems,
        props: true
    }
]